import React from 'react';
import {
  Table,
  ResultsHeader,
  ResultsData,
  ResultsHeaderRow,
  ResultsRow,
} from 'components/styled-components';
import { Button, NonIdealState } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import map from 'lodash/map';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import styled from 'styled-components';
import { shouldBold } from 'utils/functions';

const UserTable = ({ users, handleEditClick, appUser, query }) => {
  return (
    <>
      <Table>
        <tbody>
          <ResultsHeaderRow>
            <ResultsHeader>ID</ResultsHeader>
            <ResultsHeader>Name & Email</ResultsHeader>
            <ResultsHeader>User Status</ResultsHeader>
            <ResultsHeader>Role</ResultsHeader>
            <ResultsHeader>Third Party Name</ResultsHeader>
            {hasPermission(
              appUser.permissions,
              permissions.VIEW_DEPARTMENTS
            ) && <ResultsHeader>Department</ResultsHeader>}
            {/* Empty for edit button */}
            {hasPermission(appUser.permissions, permissions.MODIFY_USERS) && (
              <ResultsHeader />
            )}
          </ResultsHeaderRow>
          {users &&
            map(users, u => (
              <ResultsRow key={u.userID}>
                <TableDataWithHeaders>{u.userID}</TableDataWithHeaders>
                <TableDataWithHeaders>
                  <div>
                    {shouldBold(u.firstName, query)}{' '}
                    {shouldBold(u.lastName, query)}
                  </div>
                  <div>{shouldBold(u.email, query)}</div>
                </TableDataWithHeaders>
                <TableDataWithHeaders>{u.status}</TableDataWithHeaders>
                <TableDataWithHeaders>
                  {shouldBold(u.roleDisplayName, query)}
                </TableDataWithHeaders>
                <TableDataWithHeaders>
					{u.thirdParties === null ? "N/A" :
						shouldBold(u.thirdParties.map(tp => tp.thirdParty).join(', '), query)
					}
                </TableDataWithHeaders>
                {hasPermission(
                  appUser.permissions,
                  permissions.VIEW_DEPARTMENTS
                ) && (
                  <TableDataWithHeaders>
                    {shouldBold(u.department, query) || 'N/A'}
                  </TableDataWithHeaders>
                )}
                {hasPermission(
                  appUser.permissions,
                  permissions.MODIFY_USERS
                ) && (
                  <TableDataWithHeaders>
                    <Button
                      icon={IconNames.EDIT}
                      minimal={true}
                      onClick={() => handleEditClick(u)}
                    />
                  </TableDataWithHeaders>
                )}
              </ResultsRow>
            ))}
        </tbody>
      </Table>
      {!users && (
        <NonIdealState
          icon={query ? 'search' : 'error'}
          title="No Users Found"
          description={
            query
              ? 'Your search did not return any results'
              : 'There was an error fetching users.'
          }
        />
      )}
    </>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
	*/
    &:nth-of-type(1):before {
      content: 'ID';
    }
    &:nth-of-type(2):before {
      content: 'Name & Email';
    }
    &:nth-of-type(3):before {
      content: 'User Status';
    }
    &:nth-of-type(4):before {
      content: 'Role';
    }
    &:nth-of-type(5):before {
      content: 'Third Party Name';
    }
    &:nth-of-type(6):before {
      content: 'Department';
    }
    &:nth-of-type(7):before {
      content: 'Edit';
    }
  }
`;

export default UserTable;
